export default {
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(date);
        },
        formatDateInput(timeString) {
            const date = new Date(timeString);
            return new Intl.DateTimeFormat('en-GB').format(date)
        },
        formatTime(timeString) {
            const date = new Date(timeString);
            return new Intl.DateTimeFormat('default', {hour: 'numeric', minute: 'numeric', second: 'numeric'}).format(date);
        },
        formatTimeDashed(timeString) {
            const date = new Date(timeString);
            return date.getFullYear+"-"+date.getMonth+"-"+date.getDay;
        }
    }
}